let lastSelectedFeature = null;

let lastSelectedLayerType = null;
let currentActiveButton = "CA";
let filter = null;
const marker = new mapboxgl.Marker({ color: "#003a7c", offset: [5, -12] });

document.getElementById("toggleCel20")?.style.setProperty("display", "none");

// === device.js ===

const isMobile = () => {
  const md = new MobileDetect(window.navigator.userAgent);
  return md.phone() !== null || md.tablet() !== null;
};

// === state.js ===
let selectedLayerCel20 = null;
let selectedLayer =
  document.querySelector('input[name="layerOptions"]:checked')?.value ||
  "streets";

let clickMap = false;

// === map-init.js ===

const getInitialMapParams = () => {
  const textdummyV = document.getElementById("textdummy");

  if (isMobile()) {
    if (textdummyV) textdummyV.style.removeProperty("display");
    return {
      center: [6.8548887, 46.75694],
      zoom: 14,
      bounds: [
        [6.05, 44],
        [8.89, 49.35],
      ],
    };
  } else {
    if (textdummyV) textdummyV.style.setProperty("display", "none");
    return {
      center: [7.043090511999175, 46.72],
      zoom: 15,
      bounds: [
        [5.75, 46.2],
        [8.1, 47.3],
      ],
    };
  }
};

const { center, zoom, bounds } = getInitialMapParams();

mapboxgl.accessToken = mapboxAccessToken;

const map = new mapboxgl.Map({
  container: "containerMap",
  style: swisstopoMapStyle,
  center,
  zoom,
  maxZoom: 20,
  attributionControl: true,
  customAttribution: source,
  maxBounds: bounds,
});

map.addControl(
  new mapboxgl.NavigationControl({ showCompass: false }),
  "top-left"
);
map.addControl(new mapboxgl.ScaleControl());

const geocoder = new MapboxGeocoder({
  accessToken: mapboxgl.accessToken,
  language: langmapbox,
  mapboxgl,
  country: "CHE",
  flyTo: { zoom: 17 },
  marker: false,
});

document.getElementById("geocoder").appendChild(geocoder.onAdd(map));

geocoder.on("result", function (e) {
  marker.setLngLat(e.result.center).addTo(map);

  lastSelectedFeature = null;
  lastSelectedLayerType = null;

  // Aucun point cliqué → réinitialiser les filtres
  map.setPaintProperty("pointCELALL", "circle-color", deselectedColor);

  if (currentActiveButton === "CA" || !currentActiveButton) {
    map.setFilter("pointCELALL", ["all", ["!=", "ID_CA", 0]]);
  } else if (currentActiveButton === "CEL40") {
    map.setFilter("pointCELALL", ["all", ["!=", "ID_CEL_40", 0]]);
  } else if (currentActiveButton === "CEL20") {
    map.setFilter("pointCELALL", ["all", ["!=", "ID_CEL_20", 0]]);
  } else if (currentActiveButton === "CELMT") {
    map.setFilter("pointCELALL", ["all", ["!=", "ID_CEL_MT4", 0]]);
  }

  if (currentActiveButton === "CA" || !currentActiveButton) {
    selectedLayerCel20 = null;
    document
      .getElementById("toggleCel20")
      ?.style.setProperty("display", "none");

    // Activer la première option de toggleCel20
    const cel20Inputs = document.querySelectorAll(
      'input[name="layerOptionsCEL20"]'
    );
    if (cel20Inputs.length > 0) {
      cel20Inputs.forEach((input, index) => {
        input.checked = index === 0; // coche uniquement le premier
      });
      selectedLayerCel20 = cel20Inputs[0].value;
    }
  }
});
// === layers.js ===
function addSources() {
  map.addSource("CEL_ALL", {
    type: "vector",
    tiles: [urlMVTCelAllGreE],
    minzoom: 12,
    maxzoom: 21,
    generateId: true,
  });
}

function addLayers() {
  const baseLayerProps = {
    type: "circle",
    maxzoom: 21,
    minzoom: 12,
    layout: { visibility: "visible" },
    paint: {
      "circle-opacity": 1,
      "circle-color": deselectedColor,
      "circle-stroke-width": 0.8,
      "circle-stroke-color": "black",
      "circle-translate": [5, 5],
    },
  };
  map.addLayer({
    id: "pointCELALL",
    ...baseLayerProps,
    source: "CEL_ALL",
    "source-layer": layerNameMSCelAll,
  });
}

// === filters.js ===
function applyFilters() {
  if (lastSelectedFeature) {
    if (
      selectedLayerCel20 === "mycommune" &&
      lastSelectedFeature &&
      currentActiveButton === "CEL20"
    ) {
      filter = [
        "all",
        ["==", "COMMUNE", lastSelectedFeature.properties.COMMUNE],
        ["!=", "ID_CEL_MT20", 0],
      ];
      map.setPaintProperty("pointCELALL", "circle-color", [
        "get",
        "HTMLCol_00",
      ]);
      map.flyTo({ center: lastSelectedFeature.geometry.coordinates, zoom: 12 });
    } else if (
      selectedLayerCel20 === "mycommune" &&
      lastSelectedFeature &&
      currentActiveButton === "CEL40"
    ) {
      filter = [
        "all",
        ["==", "COMMUNE", lastSelectedFeature.properties.COMMUNE],
        ["!=", "ID_CEL_40", 0],
      ];
      map.setPaintProperty("pointCELALL", "circle-color", [
        "get",
        "HTMLCol_CE",
      ]);
      map.flyTo({ center: lastSelectedFeature.geometry.coordinates, zoom: 12 });
    } else if (
      selectedLayerCel20 === "mycommune" &&
      lastSelectedFeature &&
      currentActiveButton === "CELMT"
    ) {
      filter = [
        "all",
        ["==", "COMMUNE", lastSelectedFeature.properties.COMMUNE],
        ["!=", "ID_CEL_MT4", 0],
      ];
      map.setPaintProperty("pointCELALL", "circle-color", [
        "get",
        "HTMLCol_01",
      ]);
      map.flyTo({ center: lastSelectedFeature.geometry.coordinates, zoom: 12 });
    } else if (
      (selectedLayerCel20 === "mycommune" || !selectedLayerCel20) &&
      lastSelectedFeature &&
      currentActiveButton === "CA"
    ) {
      filter = [
        "all",
        ["==", "ID_CA", lastSelectedFeature.properties.ID_CA],
        ["!=", "ID_CA", 0],
      ];
      map.setPaintProperty("pointCELALL", "circle-color", "red");
      map.flyTo({ center: lastSelectedFeature.geometry.coordinates, zoom: 17 });
    } else if (
      selectedLayerCel20 === "mycel" &&
      lastSelectedFeature &&
      currentActiveButton === "CEL20"
    ) {
      filter = [
        "all",
        ["==", "ID_CEL_20", lastSelectedFeature.properties.ID_CEL_20],
        ["!=", "ID_CEL_20", 0],
      ];
      map.setPaintProperty("pointCELALL", "circle-color", "red");
      map.flyTo({ center: lastSelectedFeature.geometry.coordinates, zoom: 13 });
    } else if (
      selectedLayerCel20 === "mycel" &&
      lastSelectedFeature &&
      currentActiveButton === "CELMT"
    ) {
      filter = [
        "all",
        ["==", "ID_CEL_MT4", lastSelectedFeature.properties.ID_CEL_MT4],
        ["!=", "ID_CEL_MT4", 0],
      ];
      map.setPaintProperty("pointCELALL", "circle-color", "red");
      map.flyTo({ center: lastSelectedFeature.geometry.coordinates, zoom: 15 });
    } else if (
      selectedLayerCel20 === "mycel" &&
      lastSelectedFeature &&
      currentActiveButton === "CEL40"
    ) {
      filter = [
        "all",
        ["==", "ID_CEL_40", lastSelectedFeature.properties.ID_CEL_40],
        ["!=", "ID_CEL_40", 0],
      ];
      map.setPaintProperty("pointCELALL", "circle-color", "red");
      map.flyTo({ center: lastSelectedFeature.geometry.coordinates, zoom: 15 });
    } else if (
      selectedLayerCel20 === "mycel" &&
      lastSelectedFeature &&
      currentActiveButton === "CA"
    ) {
      filter = [
        "all",
        ["==", "ID_CA", lastSelectedFeature.properties.ID_CA],
        ["!=", "ID_CA", 0],
      ];
      map.setPaintProperty("pointCELALL", "circle-color", "red");
      map.flyTo({ center: lastSelectedFeature.geometry.coordinates, zoom: 17 });
    } else {
      map.setPaintProperty("pointCELALL", "circle-color", deselectedColor);
      map.flyTo({ center: lastSelectedFeature.geometry.coordinates, zoom: 14 });
    }

    map.setFilter("pointCELALL", filter);
  }
}

// === events.js ===
function setupEventHandlers() {
  map.on("click", "pointCELALL", (event) => {
    const feature = event.features[0];
    if (feature) {
      lastSelectedFeature = feature;

      marker.setLngLat(feature.geometry.coordinates).addTo(map);

      applyFilters();

      if (currentActiveButton == "CA") {
        map.flyTo({ center: feature.geometry.coordinates, zoom: 17 });
      } else {
        map.flyTo({ center: feature.geometry.coordinates, zoom: 15 });
      }
    }
  });
}

function setupStyleSwitcher() {
  const styleInputs = document.querySelectorAll('input[name="layerOptions"]');
  styleInputs.forEach((input) => {
    input.addEventListener("change", (event) => {
      selectedLayer = event.target.value;
      const styleUrl =
        selectedLayer === "streets" ? swisstopoMapStyle : imageryBaseMap;

      map.setStyle(styleUrl); //va reload le style

      // Réappliquer les filtres CEL20 si sélection en cours

      if (currentActiveButton != "CA") {
        document.getElementById("toggleCel20")?.style.removeProperty("display");
      } else {
        document
          .getElementById("toggleCel20")
          ?.style.setProperty("display", "none");
      }
    });
  });
}

// === setupUI.js ===

function setupMapContentSwitching() {
  const buttons = [
    { id: "CAButton", key: "CA" },
    { id: "CEL20Button", key: "CEL20" },
    { id: "CEL40Button", key: "CEL40" },
    { id: "CELMTButton", key: "CELMT" },
  ];

  buttons.forEach(({ id, key }) => {
    const btn = document.getElementById(id);
    if (btn) {
      btn.addEventListener("click", () => switchMapContent(key));
    }
  });
}

// ==== ui.js ====

function setupCel20ToggleFilters() {
  const cel20Inputs = document.querySelectorAll(
    'input[name="layerOptionsCEL20"]'
  );

  cel20Inputs.forEach((input) => {
    input.addEventListener("change", (event) => {
      selectedLayerCel20 = event.target.value;
      applyFilters();
    });
  });
}

function setupCursorPointerOnLayers(layerIds) {
  layerIds.forEach((layerId) => {
    map.on("mouseenter", layerId, () => {
      map.getCanvas().style.cursor = "pointer";
    });

    map.on("mouseleave", layerId, () => {
      map.getCanvas().style.cursor = "";
    });
  });
}

function switchMapContent(styleKey) {
  if (styleKey === "CA") {
    document.getElementById("CAButton")?.classList.add("active");
    document.getElementById("CEL20Button")?.classList.remove("active");
    document.getElementById("CEL40Button")?.classList.remove("active");
    document.getElementById("CELMTButton")?.classList.remove("active");
    document
      .getElementById("toggleCel20")
      ?.style.setProperty("display", "none");
    currentActiveButton = "CA";
    map.setFilter("pointCELALL", ["all", ["!=", "ID_CA", 0]]);
    selectedLayerCel20 = "mycel";

    // Activer la première option de toggleCel20
    const cel20Inputs = document.querySelectorAll(
      'input[name="layerOptionsCEL20"]'
    );
    if (cel20Inputs.length > 0) {
      cel20Inputs.forEach((input, index) => {
        input.checked = index === 0; // coche uniquement le premier
      });
      selectedLayerCel20 = cel20Inputs[0].value;
    }
  } else if (styleKey === "CEL20") {
    document.getElementById("CEL20Button")?.classList.add("active");
    document.getElementById("CAButton")?.classList.remove("active");
    document.getElementById("CEL40Button")?.classList.remove("active");
    document.getElementById("CELMTButton")?.classList.remove("active");

    document.getElementById("toggleCel20")?.style.removeProperty("display");

    currentActiveButton = "CEL20";
    map.setFilter("pointCELALL", ["all", ["!=", "ID_CEL_20", 0]]);

    if (!selectedLayerCel20) {
      selectedLayerCel20 = "mycel";
    }
  } else if (styleKey === "CEL40") {
    document.getElementById("CEL40Button")?.classList.add("active");
    document.getElementById("CAButton")?.classList.remove("active");
    document.getElementById("CEL20Button")?.classList.remove("active");
    document.getElementById("CELMTButton")?.classList.remove("active");

    document.getElementById("toggleCel20")?.style.removeProperty("display");

    currentActiveButton = "CEL40";
    map.setFilter("pointCELALL", ["all", ["!=", "ID_CEL_40", 0]]);
    if (!selectedLayerCel20) {
      selectedLayerCel20 = "mycel";
    }
  } else if (styleKey === "CELMT") {
    document.getElementById("CELMTButton")?.classList.add("active");
    document.getElementById("CAButton")?.classList.remove("active");
    document.getElementById("CEL20Button")?.classList.remove("active");
    document.getElementById("CEL40Button")?.classList.remove("active");

    document.getElementById("toggleCel20")?.style.removeProperty("display");

    currentActiveButton = "CELMT";
    map.setFilter("pointCELALL", ["all", ["!=", "ID_CEL_MT4", 0]]);
    if (!selectedLayerCel20) {
      selectedLayerCel20 = "mycel";
    }
  }

  applyFilters();

  setupMobileSidebarToggle();
  const clseButton = document.getElementById("closeSidebar");

  if (clseButton) {
    clseButton.click();
  }
}

const buttons = document.querySelectorAll(".btn-group-vertical .btn");
buttons.forEach((btn) => {
  btn.addEventListener("click", () => {
    buttons.forEach((b) => b.classList.remove("btn-primary", "active"));
    btn.classList.add("btn-primary", "active");
  });
});

function setupMapClickResetFilters() {
  map.on("click", (event) => {
    const features = map.queryRenderedFeatures(event.point, {
      layers: ["pointCELALL"],
    });

    if (features.length === 0) {
      lastSelectedFeature = null;
      lastSelectedLayerType = null;
    }

    if (features.length === 0) {
      //reset geocoder
      geocoder.clear();
      document
        .getElementsByClassName("mapboxgl-ctrl-geocoder--input")[0]
        .blur();

      // Aucun point cliqué → réinitialiser les filtres
      map.setPaintProperty("pointCELALL", "circle-color", deselectedColor);

      if (currentActiveButton === "CA" || !currentActiveButton) {
        map.setFilter("pointCELALL", ["all", ["!=", "ID_CA", 0]]);
      } else if (currentActiveButton === "CEL40") {
        map.setFilter("pointCELALL", ["all", ["!=", "ID_CEL_40", 0]]);
      } else if (currentActiveButton === "CEL20") {
        map.setFilter("pointCELALL", ["all", ["!=", "ID_CEL_20", 0]]);
      } else if (currentActiveButton === "CELMT") {
        map.setFilter("pointCELALL", ["all", ["!=", "ID_CEL_MT4", 0]]);
      }

      // remove marker
      marker.remove();

      if (currentActiveButton === "CA" || !currentActiveButton) {
        selectedLayerCel20 = null;
        document
          .getElementById("toggleCel20")
          ?.style.setProperty("display", "none");

        // Activer la première option de toggleCel20
        const cel20Inputs = document.querySelectorAll(
          'input[name="layerOptionsCEL20"]'
        );
        if (cel20Inputs.length > 0) {
          cel20Inputs.forEach((input, index) => {
            input.checked = index === 0; // coche uniquement le premier
          });
          selectedLayerCel20 = cel20Inputs[0].value;
        }
      }
    }
  });
}

function setupMobileSidebarToggle() {
  const collapseBtn = document.getElementById("mobile-collapse");
  const closeBtn = document.getElementById("closeSidebar");
  const sidebar = document.querySelector(".pc-sidebar");
  const toggleLayers = document.getElementById("toggleLayers");
  const toggleCel20 = document.getElementById("toggleCel20");
  const datamaj = document.getElementById("date-container");

  // Ouverture du panneau
  if (collapseBtn && sidebar) {
    collapseBtn.addEventListener("click", () => {
      sidebar.classList.add("mob-sidebar-active");

      document.getElementById("textSearch")?.style.removeProperty("display");

      if (closeBtn) {
        closeBtn.innerHTML = '<i data-feather="x"></i>';
        feather.replace(); // Important pour afficher l'icône
      }

      if (toggleLayers) toggleLayers.style.setProperty("display", "none");
      if (toggleCel20) toggleCel20.style.setProperty("display", "none");
      if (datamaj) datamaj.style.setProperty("display", "none");
    });
  }

  // Fermeture du panneau
  if (closeBtn && sidebar) {
    closeBtn.addEventListener("click", () => {
      sidebar.classList.remove("mob-sidebar-active");

      if (toggleLayers) toggleLayers.style.removeProperty("display");
      if (datamaj) datamaj.style.removeProperty("display");

      if (
        currentActiveButton === "CEL20" ||
        currentActiveButton === "CEL40" ||
        currentActiveButton === "CELMT"
      ) {
        if (toggleCel20) toggleCel20.style.removeProperty("display");
      } else {
        if (toggleCel20) toggleCel20.style.setProperty("display", "none");
      }

      clickMap = false;
    });
  }
}

function setupMobileInitialUI() {
  if (isMobile()) {
    document.getElementById("titre")?.style.setProperty("display", "none");

    const closeSidebar = document.getElementById("closeSidebar");
    if (closeSidebar) {
      closeSidebar.innerHTML = '<i data-feather="x"></i>';
    }
    feather.replace();
    const closeLabel = document.getElementById("closeLabel");
    if (closeLabel) {
      closeLabel.innerHTML = fermer; // Assure-toi que `fermer` est défini
    }

    document.getElementById("containerLangue")?.style.removeProperty("display");

    // Si tu veux aussi cacher les couches :
    document
      .getElementById("toggleCel20")
      ?.style.setProperty("display", "none");
  }
}

// === main.js ===

map.on("style.load", () => {
  // Ajout des sources et couches
  addSources();
  addLayers();
  applyFilters();

  // Réorganisation des couches si nécessaire
  if (selectedLayer === "streets") {
    map.removeLayer("public_transport");
    map.removeLayer("hillshade_grey");
    map.removeLayer("hillshade_yellow");
    map.removeLayer("landcover_pt");

    // Appliquer les styles spécifiques
    const st = [
      "interpolate",
      ["exponential", 0.8],
      ["zoom"],
      8,
      1,
      12,
      1,
      14,
      1,
    ];
    const st2 = [
      "interpolate",
      ["exponential", 1.09],
      ["zoom"],
      2,
      ["match", ["get", "admin_level"], 2, 1, 1],
      6,
      ["match", ["get", "admin_level"], 2, 1.5, 1],
      8,
      ["match", ["get", "admin_level"], 2, 4.5, 1],
      9,
      ["match", ["get", "admin_level"], 2, 6, 3],
      12,
      ["match", ["get", "admin_level"], 2, 10, 4, 5, 3],
      18,
      ["match", ["get", "admin_level"], 2, 24, 4, 16, 7],
      20,
      ["match", ["get", "admin_level"], 2, 40, 4, 32, 13],
    ];

    map.setPaintProperty("boundary_dashed_band", "line-opacity", st);
    map.setPaintProperty("boundary_dashed_band", "line-width", st2);
    map.setLayerZoomRange("boundary_label_l", 0);
    map.setLayerZoomRange("boundary_label_r", 0);

    [
      "place_country",
      "place_city",
      "place_town_village",
      "place_other",
      "boundary_dashed_band",
    ].forEach((layerId) => {
      if (map.getLayer(layerId)) {
        map.moveLayer(layerId);
      }
    });
  }
});

function resetToggle() {
  // Sélectionne tous les inputs radio du groupe
  const radios = document.querySelectorAll('input[name="layerOptions"]');

  // Réinitialise : coche le premier et décoche les autres
  radios.forEach((radio, index) => {
    radio.checked = index === 0; // coche le premier (streetsLayer)
  });
}


async function checkApiHealth() {
  try {
    const controller = new AbortController();
    setTimeout(() => controller.abort(), 3000);

    const res = await fetch(url_api_health, { signal: controller.signal });
    if (!res.ok) {
      toggleBanner(true);
      return;
    }

    const blobcheck = await res.blob();;

    //Check that data exists and is not empty
    const hasData = (blobcheck.size > 0) && (blobcheck.type === 'application/vnd.mapbox-vector-tile');


    toggleBanner(!hasData);
  } catch {
    toggleBanner(true);
  }
}



function toggleBanner(show) {
  const banner = document.getElementById('api-banner');
  banner.classList.toggle('hidden', !show);
}



//Run immediately at page load
checkApiHealth();

// Run every 30 seconds
setInterval(checkApiHealth, 30_000);



map.on("load", () => {
  setupEventHandlers();
  setupMapContentSwitching();
  setupCursorPointerOnLayers(["pointCELALL"]);
  setupStyleSwitcher();
  setupCel20ToggleFilters();
  setupMapClickResetFilters();
  setupMobileInitialUI();
  setupMobileSidebarToggle();
  resetToggle();
});
